import Swiper from 'swiper';

const contentsPage = $('#contents').length;

export function contentsFunc() {
  if (contentsPage) {
    if ($('#recommendSlider').length) {
      const breakPoint = 750;
      let mySwiper;
      let mySwiperBool;

      window.addEventListener('resize', () => {
        if (breakPoint < window.innerWidth && mySwiperBool) {
          mySwiper.destroy(false, true);
          mySwiperBool = false;
        } else if (breakPoint >= window.innerWidth && !(mySwiperBool)) {
          createSwiper();
          mySwiperBool = true;
        }
      }, false);

      const createSwiper = () => {
        mySwiper = new Swiper('#recommendSlider', {
          speed: 1500,
          slideToClickedSlide: true,
          slidesPerView: 'auto',
          loop: true,
          centeredSlides: true,
          slidesPerView: 1.5,
          navigation: {
            nextEl: '.recommendNext',
            prevEl: '.recommendPrev',
          },
          breakpoints: {
            751: {
              spaceBetween: 10
            },
            320: {
              spaceBetween: 20
            }
          },
          preloadImages: false,
          lazy: {
            elementClass: 'lazyload',
            loadPrevNextAmount: 2,
            loadPrevNext: true
          }
        });
      }

      if (breakPoint < window.innerWidth) {
        mySwiperBool = false;
      } else {
        createSwiper();
        mySwiperBool = true;
      }
    }

    if ($('#gallerySlider').length) {
      let gallerySwiper, galleryOptions;
      gallerySwiper = undefined;
      galleryOptions = {
        loop: true,
        speed: 800,
        effect: 'slide',
        normalizeSlideIndex: true,
        paginationClickable: true,
        centeredSlides: true,
        slidesPerView: 1,
        loopAdditionalSlides: 1,
        navigation: {
          nextEl: '.galleryNext',
          prevEl: '.galleryPrev',
        },
        breakpoints: {
          751: {
            spaceBetween: 60
          },
          320: {
            spaceBetween: 20
          }
        },
        preloadImages: false,
        lazy: {
          elementClass: 'lazyload',
          loadPrevNextAmount: 2,
          loadPrevNext: true
        }
      };

      function initGallerySwiper() {
        gallerySwiper = new Swiper('#gallerySlider', galleryOptions);
      }
      initGallerySwiper();
    }
    
    let voiceArchiveList = $('.voiceArchiveList');
    let voiceArchiveListItem = $('.voiceArchiveListItem').length;
    console.log(voiceArchiveListItem);
    if(voiceArchiveListItem % 4 == 3){
      voiceArchiveList.append('<li class="voiceArchiveListItem pcOnly"></i>');
    } else if (voiceArchiveListItem % 4 == 2){
      voiceArchiveList.append('<li class="voiceArchiveListItem pcOnly"></i><li class="voiceArchiveListItem pcOnly"></i>');
    } else if (voiceArchiveListItem % 4 == 1){
      voiceArchiveList.append('<li class="voiceArchiveListItem pcOnly"></i><li class="voiceArchiveListItem pcOnly"></i><li class="voiceArchiveListItem pcOnly"></i>');
    }
    
  }
}
